import React from "react"
import PlayerPlate from "./Display Types/player_plate"
import TeamPlate from "./Display Types/team_record_plate"
import TeamPlateSeason from "./Display Types/team_season_plate"
import CoachPlate from "./Display Types/coach_plate"



const PlateDisplay = ({ nodeData, plateType, index, sortDirection, dataLength=0, tableScrolled=false}) => {

    // check how name plate should be displayed and return component //

    if (plateType === 'team') {

        return (

            <TeamPlate
                nodeData={nodeData}
                index={index}
                sortDirection={sortDirection}
            />

        )

    } else if (plateType === 'teamSeason') {

        return (

            <TeamPlateSeason
                nodeData={nodeData}
                index={index}
            />

        )

    } else if (plateType === 'player') {

        return (

            <PlayerPlate
                first={nodeData['first_name']}
                last={nodeData['last_name']}
                icon={nodeData['headshot_url']}
                team={nodeData['team']}
                teamColor1={nodeData['team_color']}
                teamColor2={nodeData['team_color2']}
                pos={nodeData['position']}
                season={nodeData['season']}
                index={index}
                dataLength={dataLength}
                sortDirection={sortDirection}
                tableScrolled={tableScrolled}
            />

        )

    } else if (plateType === 'coachPlate') {

        return (

            <CoachPlate
                coachName={nodeData['coach']}
                imageUrl={nodeData['pfr_coach_image_url']}
                index={index}
            />

        )

    }
    
    else {

        return (

            <div>
                filler
            </div>

        
        )

    } 

}

export default PlateDisplay